import { gql } from "@apollo/client";
import moment from "moment";

export const GET_CONTRATOS_VISITA = gql`
query evaluacionesByIdPaciente($idPaciente: Int!) {
    evaluacionesByIdPaciente(idPaciente: $idPaciente){
        idEvaluacion
        fechaDesde
        fechaHasta
        idPlanCuidadoNavigation {
            nombre
            idTipoModuloNavigation {
                descripcion
                abreviacion
            }
        }
    }
}`;

export const parseContratosVisita = (contratos) =>
structuredClone(contratos).map((contrato) => ({
  idEvaluacion: contrato?.idEvaluacion,
  nombrePlan: contrato?.idPlanCuidadoNavigation ? `${contrato?.idPlanCuidadoNavigation?.idTipoModuloNavigation?.descripcion} - ${contrato?.idPlanCuidadoNavigation?.idTipoModuloNavigation?.abreviacion}` : '',
  periodo: contrato?.fechaDesde ? `${moment(contrato?.fechaDesde).format('DD/MM/YYYY')} - ${moment(contrato?.fechaHasta).format('DD/MM/YYYY')}` : ''
}));